export const SERVICE_PROVIDER_CONTRACTS_PATH =
  "api/contracts/admin/service-provider";
export const MATCH_LOCKER_SHIPMENTS_PATH = `${SERVICE_PROVIDER_CONTRACTS_PATH}/match-locker-shipments`;
export const SETTLE_LOCKER_SHIPMENTS_PATH = `${SERVICE_PROVIDER_CONTRACTS_PATH}/settle-locker-shipments`;
